import i18n from '@/lang/i18n'
import { Options } from 'highcharts'
import { uniqueId } from 'lodash'

export const highchartDefaultOptions = (): Options => {
    const colorChart: string = '#707070'
    return {
        chart: {
            style: {
                fontFamily: 'Roboto, sans-serif'
            }
        },
        title: {
            text: '',
            style: {
                fontSize: '17px',
                color: colorChart
            }
        },
        subtitle: {
            text: ''
        },
        exporting: {
            buttons: {
                contextButton: {
                    symbol: 'menuball',
                    symbolStrokeWidth: 2,
                    symbolFill: colorChart,
                    symbolStroke: colorChart,
                    symbolSize: 12,
                    x: 5,
                    y: 5,
                    menuItems: ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadSVG', 'separator', 'downloadPDF', 'downloadCSV', 'downloadXLS'],
                    theme: {
                        fill: colorChart
                    }
                }
            }
        },
        lang: {
            exitFullscreen: i18n.tc('chart.contextButton.exitFullscreen'),
            viewFullscreen: i18n.tc('chart.contextButton.viewInFullScreen'),
            printChart: i18n.tc('chart.contextButton.printChart'),
            downloadPNG: i18n.tc('chart.contextButton.downloadPNG'),
            downloadPDF: i18n.tc('chart.contextButton.downloadPDF'),
            downloadJPEG: i18n.tc('chart.contextButton.downloadJPEG'),
            downloadSVG: i18n.tc('chart.contextButton.downloadSVG'),
            downloadCSV: i18n.tc('chart.contextButton.downloadCSV'),
            downloadXLS: i18n.tc('chart.contextButton.downloadXLS'),
            noData: i18n.tc('chart.contextButton.noData'),
            contextButtonTitle: i18n.tc('chart.contextButton.contextButtonTitle')
        },
        credits: {
            enabled: false
        },
        noData: {
            style: {
                fontSize: '13px',
                color: colorChart
            }
        },
        xAxis: {
            labels: {
                style: {
                    color: colorChart
                }
            },
            title: {
                style: {
                    color: colorChart
                }
            }
        },
        yAxis: {
            labels: {
                style: {
                    color: colorChart
                }
            },
            title: {
                style: {
                    color: colorChart
                }
            }
        },
        legend: {
            itemStyle: {
                color: colorChart
            }
        },
        tooltip: {
            style: {
                color: colorChart
            }
        },
        plotOptions: {
            series: {
                dataLabels: {
                    style: {
                        color: colorChart
                    }
                }
            }
        }
    }
}

export interface HighchartsState {
    chartUID: string
    chartOptions: Options
}
export const initialHighchartState =
    (): HighchartsState => ({
        chartUID: uniqueId(),
        chartOptions: {}
    })
